import import_latest_version_module from '@/component/admin-layout/import_latest_version_module';

export default {
  path: '',
  component: () => import_latest_version_module(),
  children: [
    {
      path: '/admin/train-product-set',
      name: 'admin-train-product-set',
      component: () => import(/* webpackChunkName: "page-admin-train-product-set-train-product-set" */ `./index.vue`),
      meta: {
          data_for_admin_layout: {
                    data_for_history_tag: {
                              entity: {
                                        name: "产品设置"
                              }
                    },
                    data_for_breadcrumb: {
                              entity_list: [
                                        {
                                                  name: "火车票产品设置"
                                        },
                                        {
                                                  name: "产品设置"
                                        }
                              ]
                    }
          }
},
    },
  ],
};
